import { Injectable } from "@angular/core";
import { DataService } from "@app/core/services/data.service";
import { RetentionCenterAccount } from "@app/models";

import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class RetentionCenterService {
  private serviceUrl = "retentionCenterPlatform";
  constructor(private http: DataService) {}
  createAccount(userId: number, account: RetentionCenterAccount): Observable<RetentionCenterAccount> {
    return this.http.post(`${this.serviceUrl}/user/${userId}`, account);
  }
}
